import React, { useState } from "react";
import { UI } from "@/content/site";
import { useQuery } from "@tanstack/react-query";
import { fetchTestimonials } from "@/lib/api";

export default function TestimonialGrid({ section, lang }) {
  const [filter, setFilter] = useState(lang);
  const { data: fetched } = useQuery({
    queryKey: ["testimonials"],
    queryFn: () => fetchTestimonials(),
    staleTime: Infinity,
  });

  const items = section?.items?.length ? section.items : (fetched || []);
  const filtered = filter === "all" ? items : items.filter((t) => t.lang === filter);

  return (
    <div>
      {section.heading && <>
        <span className="gw-eyebrow">{lang === "en" ? "Client Voices" : "Voces de Clientes"}</span>
        <h2 style={{maxWidth: 640}}>{section.heading}</h2>
      </>}

      <div className="gw-testimonial-filter">
        {[
          {v: "all", l: lang === "en" ? "All" : "Todos"},
          {v: "en", l: "English"},
          {v: "es", l: "Español"},
        ].map((f) => (
          <button
            key={f.v}
            type="button"
            className={`gw-testimonial-filter-btn ${filter === f.v ? "active" : ""}`}
            onClick={() => setFilter(f.v)}
          >
            {f.l}
          </button>
        ))}
      </div>

      <div className="gw-testimonial-grid">
        {filtered.slice(0, 12).map((t, i) => (
          <figure key={i} className="gw-card gw-testimonial-card">
            <div className="gw-testimonial-stars" aria-label={`${t.rating || 5} stars`}>
              {"★".repeat(t.rating || 5)}
            </div>
            <blockquote>“{t.quote}”</blockquote>
            <figcaption>
              <strong>{t.name}</strong>
              <a href={t.url || "https://g.co/kgs/TNSfgdT"} target="_blank" rel="noopener noreferrer">
                via Google
              </a>
            </figcaption>
          </figure>
        ))}
      </div>

      <div style={{textAlign: "center", marginTop: "var(--gw-space-8)"}}>
        <a
          href="https://g.co/kgs/TNSfgdT"
          target="_blank"
          rel="noopener noreferrer"
          className="gw-btn gw-btn-ghost"
        >
          {UI[lang].ctaReview_us || (lang === "en" ? "Review us on Google" : "Reseñenos en Google")}
        </a>
      </div>

      <p className="gw-muted" style={{textAlign: "center", fontSize: "0.82rem", marginTop: "var(--gw-space-4)"}}>
        {UI[lang].disclaimer}
      </p>

      <style>{`
        .gw-testimonial-filter {
          display: flex; gap: var(--gw-space-2); justify-content: center;
          margin-bottom: var(--gw-space-6);
        }
        .gw-testimonial-filter-btn {
          padding: 0.5rem 1rem;
          border: 1.5px solid var(--gw-border-strong);
          background: transparent;
          border-radius: 999px;
          font-weight: 600; font-size: 0.9rem;
          cursor: pointer;
          color: var(--gw-text-soft);
          transition: all 0.15s ease;
        }
        .gw-testimonial-filter-btn.active {
          background: var(--gw-primary);
          color: #fff;
          border-color: var(--gw-primary);
        }
        .gw-testimonial-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: var(--gw-space-5);
        }
        .gw-testimonial-card { padding: var(--gw-space-6); }
        .gw-testimonial-stars { color: var(--gw-accent); font-size: 1.15rem; margin-bottom: var(--gw-space-3); letter-spacing: 2px; }
        .gw-testimonial-card blockquote {
          margin: 0 0 var(--gw-space-4);
          font-size: 1.02rem;
          line-height: 1.6;
          color: var(--gw-text);
          font-family: var(--gw-font-serif);
          font-style: italic;
        }
        .gw-testimonial-card figcaption {
          display: flex; justify-content: space-between; align-items: center;
          border-top: 1px solid var(--gw-border);
          padding-top: var(--gw-space-3);
        }
        .gw-testimonial-card figcaption strong {
          font-family: var(--gw-font-sans);
          color: var(--gw-primary-dark);
        }
        .gw-testimonial-card figcaption a { font-size: 0.85rem; color: var(--gw-muted); }
      `}</style>
    </div>
  );
}
